import { useCallbackRef } from './useCallbackRef';

export function useConstant<GetConstantResult>(getConstant: () => GetConstantResult): GetConstantResult {
  return useCallbackRef(getConstant).current;
}
